// extracted by mini-css-extract-plugin
export default {"buttonTitle":"styles_buttonTitle__FwHLG"};